import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import Notification from 'utils/Notifications'

import { Layout } from 'components'

import styles from './QuizForm.module.scss'

import { questions } from 'constants/quizQuestions'
import { SendQuizAnswers } from 'service/AuthService'

const QuizForm = () => {
  const { t } = useTranslation('common')
  const [dataPosition, setDataPosition] = useState([])
  const [gender, setGender] = useState(null)

  const navigate = useNavigate()

  const [notify, setNotify] = useState({
    isOpen: false,
    message: '',
    type: '',
  })
  const dispatch = useDispatch()

  const [answers, setAnswers] = useState([])

  const handleAnswerChange = (question, answer) => {
    setAnswers((prevAnswers) => {
      const updatedAnswers = [...prevAnswers]
      const existingAnswer = updatedAnswers.find((a) => a.question === question)

      if (existingAnswer) {
        existingAnswer.answer = answer
      } else {
        updatedAnswers.push({ question, answer })
      }

      return updatedAnswers
    })
  }

  const handleSubmit = async (event) => {
    event.preventDefault()

    if (answers.length === questions.length) {
      try {
        let response = await SendQuizAnswers(answers)

        setNotify({
          isOpen: true,
          message: t('forms.quizForm.answers_sent_success'),
          type: 'success',
          sound: 'success',
        })

        navigate(-1)
      } catch (error) {

        setNotify({
          isOpen: true,
          message: t('common.error'),
          type: 'error',
          sound: 'error',
        })
      }
    } else {
      setNotify({
        isOpen: true,
        message: t('forms.quizForm.unanswered_questions'),
        type: 'warning',
        sound: 'warning',
      })
    }
  }

  return (
    <Layout>
      <div className={styles.container}>
        <div className={styles.title}>{t('forms.quizForm.title')}</div>
        <form className={styles.form}>
          {questions.map((question) => (
            <div className={styles.gender_details} key={question.id}>
              <p className={styles.gender_title}>{question.question_text}</p>
              <div className={styles.category}>
                <label>
                  <input
                    type="radio"
                    name={`question_${question.id}`}
                    value="true"
                    onChange={() => handleAnswerChange(question.id, true)}
                  />
                  {t('common.yes')}
                </label>
                <label>
                  <input
                    type="radio"
                    name={`question_${question.id}`}
                    value="false"
                    onChange={() => handleAnswerChange(question.id, false)}
                  />
                  {t('common.no')}
                </label>
              </div>
            </div>
          ))}
          <div style={{ textAlign: 'right', paddingTop: '15px' }}>
            <input
              className={styles.btn_pin}
              type="submit"
              onClick={handleSubmit}
              value={t('common.submit')}
            />
          </div>
        </form>

        
      </div>
      <Notification notify={notify} setNotify={setNotify} />
    </Layout>
  )
}

export default QuizForm
